import { useMutation } from '@tanstack/react-query';
import { FinancialDocumentAllocation } from '../../../../../../models/IncomingInvoices';
import { apiCreateAllocations } from '../../../../api';

interface CreateAllocationsParams {
  projectId: string;
  financialDocumentId: string;
  allocations: FinancialDocumentAllocation[];
}

export function useCreateAllocationsMutation() {
  return useMutation({
    mutationFn: async (params: CreateAllocationsParams) => {
      return apiCreateAllocations(
        params.projectId,
        params.financialDocumentId,
        params.allocations
      );
    },
  });
}
